import React from "react";
import { Divider } from "rsuite";
import styled from "styled-components";
import { Link } from "react-router-dom";
import SocialIcons from "./SocialIcons";

let whatwedo = [
  {
    title: "Overview",
    path: "/overview",
  },
  {
    title: "KRO Programming Approaches",
    path: "/programmingapproaches",
  },
  {
    title: "Livelihood & Food Security",
    path: "/livelihoodfoodsecurity",
  },
  {
    title: "WASH",
    path: "/wash",
  },
  {
    title: "Cash-based Interventions",
    path: "/cashbasedinterventions",
  },
  {
    title: "Protection",
    path: "/protection",
  },
  {
    title: "Shelter",
    path: "/shelter",
  },
  {
    title: "SBC",
    path: "/sbc",
  },
];

let media = [
  {
    title: "News Letter",
    path: "/newsletter",
  },
  {
    title: "Success Stories",
    path: "/successstories",
  },
  {
    title: "Photo Gallery",
    path: "/photogallery",
  },
  {
    title: "Video Gallery",
    path: "/videogallery",
  },
];

const Sitemap = () => {
  return (
    <Main>
      <Container>
        <Block>
          <Title>About Us</Title>
          <Item to="/aboutus">Who We Are</Item>
          <Item to="/wherewework">Where We Work</Item>
          <Item to="/historymilestone">History / Milestone</Item>
          <Item to="/accountability">Accountability</Item>
          <Item to="/complaintform">Complaints & Feedback</Item>
          <Item to="/ourteam">Our Team</Item>
          <Item to="/faq">FAQs</Item>
        </Block>

        <Block>
          <Title>What We Do</Title>
          {whatwedo.map((item, index) => {
            return (
              <Item key={index} to={item.path}>
                {item.title}
              </Item>
            );
          })}
        </Block>

        <Block>
          <Title>Media</Title>
          {media.map((item, index) => {
            return (
              <Item key={index} to={item.path}>
                {item.title}
              </Item>
            );
          })}

          <Block>
            <Title>Get Involved</Title>
            <Item to="/careeropportunities">Career Opportunities</Item>
            <Item to="/rfps">RFQs & RFPs</Item>
          </Block>
        </Block>

        <Block>
          <Single to="/impact">Impact</Single>
          <Single to="/contactus">Contact Us</Single>
          <SocialIcons />
          <FuturePlan>
            Designed & Developed By{" "}
            <Highlight>
              <a
                href="https://www.facebook.com/nasratahmad.hashme"
                target="_blank"
                rel="noopener noreferrer"
              >
                Nasrat Qurishe
              </a>
            </Highlight>
          </FuturePlan>
        </Block>
      </Container>
      <StyledDivider />
      <Section>
        <Group>
          <Heading>Vision</Heading>
          <Description>
            KRO envisions a future where local communities in Afghanistan thrive
            through robust economic development, enhanced capacities, and
            sustainable practices. We aspire to empower individuals, including
            women and those with disabilities, to reach their full potential and
            contribute to their communities' growth and prosperity.
          </Description>
        </Group>

        <Group>
          <Heading>Mission</Heading>
          <Description>
            KRO addresses humanitarian needs and rehabilitates communities in
            Afghanistan. We empower local populations, including women and
            individuals with disabilities, while promoting sustainable
            development and ensuring access to essential resources for all.
          </Description>
        </Group>

        <Group>
          <Heading>Our Goal</Heading>
          <Description>
            The primary goal of KRO is to assist and uplift the distressed,
            needy, neglected, and vulnerable populations in Afghanistan, with a
            particular focus on women and children. By providing essential
            assistance, the organization aims to contribute to the social and
            economic development of these communities, enhancing their lives and
            overall conditions. The emphasis on sustainability and
            self-determination underscores KRO's commitment to fostering lasting
            positive change at the community level.
          </Description>
        </Group>
      </Section>
    </Main>
  );
};

export default Sitemap;

const Main = styled.div`
  display: grid;
  width: 100vw;
  background: #ffffff;
  overflow: hidden;
  padding: 40px;
  box-sizing: border-box;
`;

const Container = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: 100%;
  padding: 50px 0px 0px 0px;
  box-sizing: border-box;
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 30px;
  }
`;

const Block = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.span`
  font-size: 1rem;
  font-family: "Poppins";
  font-weight: 700;
  color: #000000;
  text-transform: uppercase;
  margin-block: 15px;
`;

const Item = styled(Link)`
  font-size: 0.9rem;
  font-family: "Poppins";
  font-weight: 400;
  color: #333333;
  text-decoration: none !important;
  margin: 5px 0;
  transition: color 0.3s ease;

  &:hover {
    color: #4caf50;
  }

  &:before {
    content: "•";
    font-size: 1.2rem;
    margin-right: 8px;
    vertical-align: middle;
    color: #4caf50;
  }
`;

const Single = styled(Link)`
  font-size: 1rem;
  font-family: "Poppins";
  font-weight: 700;
  color: #000000;
  text-transform: uppercase;
  margin-block: 15px;
  text-decoration: none !important;
  transition: color 0.3s ease;

  &:hover {
    color: #4caf50;
  }
`;

const StyledDivider = styled(Divider)`
  background-color: #4caf50 !important;
  margin: 20px 0;
`;

const Section = styled.div`
  background: #f5f5f5;
  padding: 30px;
  border-radius: 4px;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-block: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #4caf50;

  &:last-child {
    border-bottom: none;
  }
`;

const Heading = styled.span`
  font-size: 1rem;
  font-family: "Poppins";
  font-weight: 700;
  color: #000000;
  text-transform: uppercase;
  margin-bottom: 10px;
`;

const Description = styled.span`
  font-family: "Poppins";
  font-weight: 400;
  font-size: 0.8rem;
  color: #333333;
  line-height: 1.6;
`;

const FuturePlan = styled.div`
  font-size: 0.9rem;
  font-family: "Poppins";
  font-weight: 400;
  color: #333333;
  text-decoration: none !important;
  margin-top: 20px;
`;

const Highlight = styled.span`
  font-size: 1rem;
  font-family: "Poppins";
  font-weight: 700;
  color: #4caf50;
  text-decoration: none !important;

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: 768px) {
    display: block;
  }
`;
